export const MOMENT_DATE_FORMAT = 'MM/DD/YYYY';
